export default {
  anyMistakes:
    'Si crees que la información que se ofrece en esta página es incorrecta',
  contactUs: 'ponte en contacto con nosotros',
  social: 'Somos sociales | Síguenos',
}
